import { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { cookie } from 'utils'
import { flirtPopup, fetchFlirts } from 'store/actions'

const useFlirtPopup = () => {
  const { accounts, index, loaded } = useSelector(s => s.flirt)
  const locationKey = useSelector(s => s.router.location.key)
  const dispatch = useDispatch()

  useEffect(() => {
    const count = cookie.get('INFRQ.99.flirt_popup', 0)
    if (!count && !loaded) {
      dispatch(fetchFlirts())
      return
    }
    if (!count && accounts[index]) {
      dispatch(flirtPopup(accounts[index]))
    }
    cookie.set('INFRQ.99.flirt_popup', (30 + count - 1) % 30)
  }, [locationKey])
}

export { useFlirtPopup as default, useFlirtPopup }
